module.exports = __webpack_public_path__ + "static/media/NEWS_aac.7971ca27.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/NEWS_aac.png
// module id = 180
// module chunks = 0